import PropTypes from 'prop-types';
import React from 'react';

const Error = ({
  color,
  size
}) => {
  const sizePx = {
    xl: '48',
    lg: '40',
    md: '32',
    sm: '24',
    xs: '16'
  }[size];
  return /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: sizePx || 32,
    height: sizePx || 28,
    viewBox: "0 0 32 28",
    "aria-label": "error"
  }, /*#__PURE__*/React.createElement("title", null, "icon_warning_red"), /*#__PURE__*/React.createElement("polygon", {
    points: "16 0 32 28 0 28 16 0",
    fill: color
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.35,15.33l-.29,3.33H14.92l-.29-3.33V11.58h2.72Zm-.11,5.07v.65c0,.73-.22.95-.93.95h-.63c-.7,0-.93-.22-.93-.95V20.4c0-.73.23-.95.93-.95h.63C17,19.45,17.24,19.67,17.24,20.4Z",
    fill: "#fff"
  }));
};

Error.propTypes = {
  size: PropTypes.oneOf(['xs', 'sm', 'md', 'lg', 'xl']),
  color: PropTypes.string
};
Error.defaultProps = {
  size: null,
  color: '#e60000'
};
export default Error;